
import { mapState, mapMutations, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'SigninContainer',
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          placement: 'account',
          require_phone_verification: false,
          phone_verification_redirect: '/account/verify-details'
        }
      }
    }
  },
  computed: {
    ...mapState([ 'token', 'cart' ]),
    accountRoute() {
      let accountLink = '/account'
      if (this.config?.require_phone_verification) {
        accountLink = this.accountPhone ? '/account' : this.config?.phone_verification_redirect
      }
      return this.config?.redirect_page_on_success ? this.config?.redirect_page_on_success : accountLink
    },
    accountPhone() {
      let valid = null
      if (this.token?.user?.phone) {
        valid = this.token?.user?.phone.replace(/[- )(]/g,'').match(/^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)
      }
      return valid ? true : false
    }
  },
  data() {
    return {
      defaultData: {
        placement: this.config.placement || 'account'
      }
    }
  },
  beforeMount() {
    if(this.config.placement === 'app') {
      this.getAppState(this.$route)
    } else if (this.token && this.accountPhone) {
      this.$router.push('/account')
    }
  },
  methods: {
    ...mapMutations([ 'setLoading', 'setErrors', 'setToken', 'setUser' ]),
    ...mapMutations({
      setGuestUser: 'checkout/setGuestUser'
    }),
    ...mapActions([ 'getAppState', 'sendRequest' ]),
    ...mapActions({
      getRewards: 'members/getRewards'
    }),
    handleEvent(method, data) {
      if(this[method]) {
        this[method](data)
      }
    },
    handleSuccess(data) {
      switch(this.config.placement) {
        case 'app':
          let token = JSON.stringify(data)
          this.$utils.log(token)
          if(window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(token)
          } else if(window.webView) {
            window.webView.postMessage(token)
          } else {
            window.parent.postMessage(token)
          }
          // this.setAppState(null)
          break
        case 'account':
        default:
          this.getUser(data, this.cart?.products?.length ? '/order/checkout' : this.accountRoute)
      }
    },
    async getUser(data, route) {
      if (data && data.expires === null && this.config?.tokenConfig?.forceRefreshToken) {
        const expirationTime = this.config?.tokenConfig?.expirationTime || 10
        const expires = moment().add(expirationTime, 'minutes')
        data.expires = moment(expires).valueOf()
        this.$utils.log(`** Token Expires in ${expirationTime} minutes`)
      }

      this.setToken(data)
      this.setLoading(true)
      const config = {
        method: 'get',
        url: 'members'
      }
      const response = await this.sendRequest(config)
      if(response.status === 'ok') {
        this.setGuestUser(null)
        this.setUser(response.data)
        this.getRewards()
      } else {
        this.setErrors(response.message)
      }
      this.setLoading(false)
      this.$router.push(route)
    }
  }
}
